import { combineReducers } from "redux";
import rdv from "./rdv";

export default combineReducers({ rdv });
